<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-3"><a id="page_xi"><strong><em>Abbreviations</em></strong></a></h1><a id="page_xi">
<table>
<tbody>
<tr>
<td class="col1"><p class="t-left">AB</p></td>
<td class="col2"><p class="t-hang">Anchor Bible</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ABD</em></p></td>
<td class="col2"><p class="t-hang"><em>Anchor Bible Dictionary</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ABR</em></p></td>
<td class="col2"><p class="t-hang"><em>Australian Biblical Review</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ACCS</p></td>
<td class="col2"><p class="t-hang">Ancient Christian Commentary on Scripture</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">AnBib</p></td>
<td class="col2"><p class="t-hang">Analecta Biblica</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ANF</em></p></td>
<td class="col2"><p class="t-hang"><em>Ante-Nicene Fathers</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ANRW</em></p></td>
<td class="col2"><p class="t-hang"><em>Aufstieg und Niedergang der römischen Welt</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ANTC</p></td>
<td class="col2"><p class="t-hang">Abingdon New Testament Commentaries</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ASNU</p></td>
<td class="col2"><p class="t-hang">Acta seminarii neotestamentici upsalienses</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ATANT</p></td>
<td class="col2"><p class="t-hang">Abhandlungen zur Theologie des Alten und Neuen Testaments</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ATD</p></td>
<td class="col2"><p class="t-hang">Das Alte Testament Deutsch</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>AUSS</em></p></td>
<td class="col2"><p class="t-hang"><em>Andrews University Seminary Studies</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BBR</em></p></td>
<td class="col2"><p class="t-hang"><em>Bulletin for Biblical Research</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BDAG</p></td>
<td class="col2"><p class="t-hang">W. Bauer, W. F. Arndt, F. W. Gingrich, and F. W. Danker, <em>Greek-English Lexicon of the New Testament</em> (2d ed.)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BDB</p></td>
<td class="col2"><p class="t-hang">F. Brown, S. R. Driver, and C. A. Briggs, <em>The New Brown-Drivers-Briggs-Gesenius Hebrew-English Lexicon</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BDF</p></td>
<td class="col2"><p class="t-hang">F. Blass, A. Debrunner, and R. W. Funk, <em>A Greek Grammar of the New Testament and Other Early Christian Literature</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BDR</p></td>
<td class="col2"><p class="t-hang">F. Blass, A. Debrunner, and F. Rehkopf, <em>Grammatik des neutestamentlichen Griechisch</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BETL</p></td>
<td class="col2"><p class="t-hang">Bibliotheca ephemeridum theologicarum lovaniensium</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BevT</p></td>
<td class="col2"><p class="t-hang">Beiträge zur evangelischen Theologie</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BFCT</p></td>
<td class="col2"><p class="t-hang">Beiträge zur Förderung christlicher Theologie</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BHT</p></td>
<td class="col2"><p class="t-hang">Beiträge zur historischen Theologie</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Bib</em></p></td>
<td class="col2"><p class="t-hang"><em>Biblica</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><a id="page_xii"><em>BibLeb</em></a></p></td>
<td class="col2"><p class="t-hang"><em>Bibel und Leben</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BN</em></p></td>
<td class="col2"><p class="t-hang"><em>Biblische Notizen</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BNTC</p></td>
<td class="col2"><p class="t-hang">Black’s New Testament Commentaries</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BR</em></p></td>
<td class="col2"><p class="t-hang"><em>Biblical Research</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BSac</em></p></td>
<td class="col2"><p class="t-hang"><em>Bibliotheca Sacra</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BT</em></p></td>
<td class="col2"><p class="t-hang"><em>The Bible Translator</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BTB</em></p></td>
<td class="col2"><p class="t-hang"><em>Biblical Theology Bulletin</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BWANT</p></td>
<td class="col2"><p class="t-hang">Beiträge zur Wissenschaft vom Alten und Neuen Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BZ</em></p></td>
<td class="col2"><p class="t-hang"><em>Biblische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BZNW</p></td>
<td class="col2"><p class="t-hang">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">CBC</p></td>
<td class="col2"><p class="t-hang">Cambridge Bible Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CBQ</em></p></td>
<td class="col2"><p class="t-hang"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">CC</p></td>
<td class="col2"><p class="t-hang">Continental Commentaries</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">CGTC</p></td>
<td class="col2"><p class="t-hang">Cambridge Greek Testament Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">CNT</p></td>
<td class="col2"><p class="t-hang">Commentaire du Nouveau Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ConBNT</p></td>
<td class="col2"><p class="t-hang">Coniectanea biblica: New Testament Series</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CTJ</em></p></td>
<td class="col2"><p class="t-hang"><em>Calvin Theological Journal</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CTQ</em></p></td>
<td class="col2"><p class="t-hang"><em>Concordia Theological Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CurTM</em></p></td>
<td class="col2"><p class="t-hang"><em>Currents in Theology and Mission</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CTM</em></p></td>
<td class="col2"><p class="t-hang"><em>Concordia Theological Monthly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>DPL</em></p></td>
<td class="col2"><p class="t-hang">G. F. Hawthorne, R. P. Martin, and D. G. Reid (eds.), <em>Dictionary of Paul and His Letters</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ÉBib</p></td>
<td class="col2"><p class="t-hang">Études bibliques</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>EDNT</em></p></td>
<td class="col2"><p class="t-hang">H. Balz and G. Schneider (eds.), <em>Exegetical Dictionary of the New Testament</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">EKKNT</p></td>
<td class="col2"><p class="t-hang">Evangelisch-katholischer Kommentar zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ESV</p></td>
<td class="col2"><p class="t-hang">English Standard Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ETL</em></p></td>
<td class="col2"><p class="t-hang"><em>Ephemerides theologicae lovanienses</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ETR</em></p></td>
<td class="col2"><p class="t-hang"><em>Etudes théologiques et religieuses</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>EvQ</em></p></td>
<td class="col2"><p class="t-hang"><em>Evangelical Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>EvT</em></p></td>
<td class="col2"><p class="t-hang"><em>Evangelische Theologie</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ExAud</em></p></td>
<td class="col2"><p class="t-hang"><em>Ex Auditu</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ExpTim</em></p></td>
<td class="col2"><p class="t-hang"><em>Expository Times</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">FB</p></td>
<td class="col2"><p class="t-hang">Forschung zur Bibel</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">FRLANT</p></td>
<td class="col2"><p class="t-hang">Forschung zur Religion und Literatur des Alten und Neuen Testaments</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">GNS</p></td>
<td class="col2"><p class="t-hang">Good News Studies</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>HBT</em></p></td>
<td class="col2"><p class="t-hang"><em>Horizons in Biblical Theology</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">HCSB</p></td>
<td class="col2"><p class="t-hang">Holman Christian Standard Bible</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">HKNT</p></td>
<td class="col2"><p class="t-hang">Handkommentar zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">HTKNT</p></td>
<td class="col2"><p class="t-hang">Herders theologischer Kommentar zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">HNT</p></td>
<td class="col2"><p class="t-hang">Handbuch zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><a id="page_xiii">HNTC</a></p></td>
<td class="col2"><p class="t-hang">Harper’s New Testament Commentaries</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>HTR</em></p></td>
<td class="col2"><p class="t-hang"><em>Harvard Theological Review</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">HUT</p></td>
<td class="col2"><p class="t-hang">Hermeneutische Untersuchungen zur Theologie</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">IBC</p></td>
<td class="col2"><p class="t-hang">Interpretation: A Bible Commentary for Teaching and Preaching</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ICC</p></td>
<td class="col2"><p class="t-hang">International Critical Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Int</em></p></td>
<td class="col2"><p class="t-hang"><em>Interpretation</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ITQ</em></p></td>
<td class="col2"><p class="t-hang"><em>Irish Theological Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">IVPNTC</p></td>
<td class="col2"><p class="t-hang">InterVarsity Press New Testament Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JAAR</em></p></td>
<td class="col2"><p class="t-hang"><em>Journal of the American Academy of Religion</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JBL</em></p></td>
<td class="col2"><p class="t-hang"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JETS</em></p></td>
<td class="col2"><p class="t-hang"><em>Journal of the Evangelical Theological Society</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JSNT</em></p></td>
<td class="col2"><p class="t-hang"><em>Journal for the Study of the New Testament</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">JSNTSup</p></td>
<td class="col2"><p class="t-hang">Journal for the Study of the New Testament: Supplement Series</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JTS</em></p></td>
<td class="col2"><p class="t-hang"><em>Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JTSA</em></p></td>
<td class="col2"><p class="t-hang"><em>Journal of Theology for Southern Africa</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>KD</em></p></td>
<td class="col2"><p class="t-hang"><em>Kerygma und Dogma</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">KEK</p></td>
<td class="col2"><p class="t-hang">Kritisch-exegetischer Kommentar über das Neue Testament (Meyer-Kommentar)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">KJV</p></td>
<td class="col2"><p class="t-hang">King James Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>LASBF</em></p></td>
<td class="col2"><p class="t-hang"><em>Liber annuus Studii biblici franciscani</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">LCL</p></td>
<td class="col2"><p class="t-hang">Loeb Classical Library</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">LD</p></td>
<td class="col2"><p class="t-hang">Lectio divina</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">LN</p></td>
<td class="col2"><p class="t-hang">J. P. Louw and E. Nida, <em>Greek-English Lexicon of the New Testament: Based on Semantic Domains</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">LSJ</p></td>
<td class="col2"><p class="t-hang">Liddell-Scott-Jones, <em>Greek English Lexicon</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>LTQ</em></p></td>
<td class="col2"><p class="t-hang"><em>Lutheran Theological Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">LXX</p></td>
<td class="col2"><p class="t-hang">Septuagint</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">MBS</p></td>
<td class="col2"><p class="t-hang">Message of Biblical Spirituality</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">MM</p></td>
<td class="col2"><p class="t-hang">J. H. Moulton and G. Milligan, <em>The Vocabulary of the Greek New Testament</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">MT</p></td>
<td class="col2"><p class="t-hang">Massoretic Text</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NA<sup>27</sup></p></td>
<td class="col2"><p class="t-hang">E. Nestle and K. Aland (eds.), <em>Novum Testamentum Graece</em> (27th ed.)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NAB</p></td>
<td class="col2"><p class="t-hang">New American Bible</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NAC</p></td>
<td class="col2"><p class="t-hang">New American Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NASB</p></td>
<td class="col2"><p class="t-hang">New American Standard Bible (rev. ed.)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NCBC</p></td>
<td class="col2"><p class="t-hang">New Century Bible Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NEB</p></td>
<td class="col2"><p class="t-hang">New English Bible</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Neot</em></p></td>
<td class="col2"><p class="t-hang"><em>Neotestamentica</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NewDocs</em></p></td>
<td class="col2"><p class="t-hang"><em>New Documents Illustrating Early Christianity</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><a id="page_xiv">NET</a></p></td>
<td class="col2"><p class="t-hang">New English Translation</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NIB</em></p></td>
<td class="col2"><p class="t-hang"><em>New Interpreters’ Bible</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NIBCNT</p></td>
<td class="col2"><p class="t-hang">New International Biblical Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NICNT</p></td>
<td class="col2"><p class="t-hang">New International Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NIDNTT</em></p></td>
<td class="col2"><p class="t-hang">C. Brown (ed.), <em>The New International Dictionary of New Testament Theology</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NIGTC</p></td>
<td class="col2"><p class="t-hang">New International Greek Testament Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NIV</p></td>
<td class="col2"><p class="t-hang">New International Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NIVAC</p></td>
<td class="col2"><p class="t-hang">New International Version Application Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NJB</p></td>
<td class="col2"><p class="t-hang">New Jerusalem Bible</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NKJV</p></td>
<td class="col2"><p class="t-hang">New King James Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NLT</p></td>
<td class="col2"><p class="t-hang">New Living Translation</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NovT</em></p></td>
<td class="col2"><p class="t-hang"><em>Novum Testamentum</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NovTSup</p></td>
<td class="col2"><p class="t-hang">Supplements to Novum Testamentum</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NPNF</em></p></td>
<td class="col2"><p class="t-hang"><em>Nicene and Post-Nicene Fathers</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NRSV</p></td>
<td class="col2"><p class="t-hang">New Revised Standard Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NRTh</em></p></td>
<td class="col2"><p class="t-hang"><em>La nouvelle revue théologique</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NSBT</p></td>
<td class="col2"><p class="t-hang">New Studies in Biblical Theology</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NTAbh</p></td>
<td class="col2"><p class="t-hang">Neutestamentliche Abhandlungen</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NTD</p></td>
<td class="col2"><p class="t-hang">Das Neue Testament Deutsch</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NTS</em></p></td>
<td class="col2"><p class="t-hang"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NTTS</p></td>
<td class="col2"><p class="t-hang">New Testament Tools and Studies</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ÖTK</p></td>
<td class="col2"><p class="t-hang">Ökumenischer Taschenbuch-Kommentar</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">PG</p></td>
<td class="col2"><p class="t-hang">Patrologia graeca</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">PNTC</p></td>
<td class="col2"><p class="t-hang">Pelican New Testament Commentaries</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>RB</em></p></td>
<td class="col2"><p class="t-hang"><em>Revue biblique</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">REB</p></td>
<td class="col2"><p class="t-hang">Revised English Bible</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ResQ</em></p></td>
<td class="col2"><p class="t-hang"><em>Restoration Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>RevExp</em></p></td>
<td class="col2"><p class="t-hang"><em>Review and Expositor</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>RevScRel</em></p></td>
<td class="col2"><p class="t-hang"><em>Revue des sciences religieuses</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>RHPR</em></p></td>
<td class="col2"><p class="t-hang"><em>Revue d’histoire et de philosophie religieuses</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">RNT</p></td>
<td class="col2"><p class="t-hang">Regensburger Neues Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>RRef</em></p></td>
<td class="col2"><p class="t-hang"><em>La revue reformée</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">RSV</p></td>
<td class="col2"><p class="t-hang">Revised Standard Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>RTR</em></p></td>
<td class="col2"><p class="t-hang"><em>Reformed Theological Review</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SANT</p></td>
<td class="col2"><p class="t-hang">Studien zum Alten und Neuen Testaments</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SBB</p></td>
<td class="col2"><p class="t-hang">Stuttgarter biblische Beiträge</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SBL</p></td>
<td class="col2"><p class="t-hang">Society of Biblical Literature</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SBLDS</p></td>
<td class="col2"><p class="t-hang">Society of Biblical Literature Dissertation Series</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SBLMS</p></td>
<td class="col2"><p class="t-hang">Society of Biblical Literature Monograph Series</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>SBLSP</em></p></td>
<td class="col2"><p class="t-hang"><em>Society of Biblical Literature Seminar Papers</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><a id="page_xv">SBM</a></p></td>
<td class="col2"><p class="t-hang">Stuttgarter biblische Monographien</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>SBT</em></p></td>
<td class="col2"><p class="t-hang"><em>Studies in Biblical Theology</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>SEÅ</em></p></td>
<td class="col2"><p class="t-hang"><em>Svensk exegetisk årsbok</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>SJLA</em></p></td>
<td class="col2"><p class="t-hang"><em>Studies in Judaism of Late Antiquity</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>SJT</em></p></td>
<td class="col2"><p class="t-hang"><em>Scottish Journal of Theology</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SNT</p></td>
<td class="col2"><p class="t-hang">Studien zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SNTSMS</p></td>
<td class="col2"><p class="t-hang">Society for New Testament Studies Monograph Series</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SNTSU</p></td>
<td class="col2"><p class="t-hang">Studien zum Neuen Testament und seiner Umwelt</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SP</p></td>
<td class="col2"><p class="t-hang">Sacra Pagina</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ST</em></p></td>
<td class="col2"><p class="t-hang"><em>Studia theological</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">Str-B</p></td>
<td class="col2"><p class="t-hang">H. L. Strack and P. Billerbeck, <em>Kommentar zum Neuen Testament aus Talmud und Midrasch</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SUNT</p></td>
<td class="col2"><p class="t-hang">Studien zur Umwelt des Neuen Testaments</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>SVTQ</em></p></td>
<td class="col2"><p class="t-hang"><em>St. Vladimir’s Theological Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>SwJT</em></p></td>
<td class="col2"><p class="t-hang"><em>Southwestern Journal of Theology</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TDNT</em></p></td>
<td class="col2"><p class="t-hang">G. Kittel and G. Friedrich (eds.), <em>Theological Dictionary of the New Testament</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">TEV</p></td>
<td class="col2"><p class="t-hang">Today’s English Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TBei</em></p></td>
<td class="col2"><p class="t-hang"><em>Theologische Beiträge</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Them</em></p></td>
<td class="col2"><p class="t-hang"><em>Themelios</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">THKNT</p></td>
<td class="col2"><p class="t-hang">Theologischer Handkommentar zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TJ</em></p></td>
<td class="col2"><p class="t-hang"><em>Trinity Journal</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TLG</em></p></td>
<td class="col2"><p class="t-hang"><em>Thesaurus linguae graecae</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">TNIV</p></td>
<td class="col2"><p class="t-hang">Today’s New International Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">TNTC</p></td>
<td class="col2"><p class="t-hang">Tyndale New Testament Commentaries</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TTE</em></p></td>
<td class="col2"><p class="t-hang"><em>The Theological Educator</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">TU</p></td>
<td class="col2"><p class="t-hang">Texte und Untersuchungen</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TynBul</em></p></td>
<td class="col2"><p class="t-hang"><em>Tyndale Bulletin</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TZ</em></p></td>
<td class="col2"><p class="t-hang"><em>Theologische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">UBS</p></td>
<td class="col2"><p class="t-hang">United Bible Societies Greek New Testament (4th ed.)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">UNT</p></td>
<td class="col2"><p class="t-hang">Untersuchungen zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>VE</em></p></td>
<td class="col2"><p class="t-hang"><em>Vox evangelica</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">WBC</p></td>
<td class="col2"><p class="t-hang">Word Biblical Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>WD</em></p></td>
<td class="col2"><p class="t-hang"><em>Wort und Dienst</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">WMANT</p></td>
<td class="col2"><p class="t-hang">Wissenschaftliche Monographien zum Alten und Neuen Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>WTJ</em></p></td>
<td class="col2"><p class="t-hang"><em>Westminster Theological Journal</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">WUNT</p></td>
<td class="col2"><p class="t-hang">Wissenschaftliche Untersuchungen zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ZB</p></td>
<td class="col2"><p class="t-hang">Zürcher Bibel</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ZBK</p></td>
<td class="col2"><p class="t-hang">Zürcher Bibelkommentare</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ZNW</em></p></td>
<td class="col2"><p class="t-hang"><em>Zeitschrift für die neutestamentliche Wissenschaft</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">ZTK</p></td>
<td class="col2"><p class="t-hang"><em>Zeitschrift für Theologie und Kirche</em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Abbreviations.vue?b76cac3a